module.exports = __webpack_public_path__ + "img/title.e8c6dfc3.png";